import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Input, Col, Button , message } from 'antd';
import { connect } from 'react-redux';
import { getUnitByMode } from '../InquiryUtils';
import { tokens } from 'src/design-system';

const { TextArea } = Input;
const styles = theme => ({
  body: {
    marginTop: '30px',
    marginBottom: '30px',
    padding: '24px 24px 24px 24px',
    height: '100%',
  },
  title: {
    fontSize: `${tokens.fontSize.h3}px`,
    fontWeight: 'bold',
    font: 'Open Sans SemiBold'
  },
  priceSubtext: {
    font: 'Open Sans SemiBold Italic',
    fontSize: '8px',
    lineHeight: '11.2px',
    fontWeight: 580
  },
  price: {
    font: 'Open Sans SemiBold',
    fontSize: '11.2px',
    lineHeight: '11.2px',
    fontWeight: 580
  },
  bidLabel: {
    font: 'Open Sans SemiBold',
    fontSize: `${tokens.fontSize.caption}px`,
    height: '12px',
    lineHeight: '10px',
    fontWeight: 580
  },
  opacity: {
    opacity: 0.58,
  }
});

class InformReason extends React.PureComponent<any, any> {
  state: any = {
    submittingReason: false,
    showMandatoryReasonError: false,
    reason: '',
  };

  setRemark = async () => {
    if (this.state.reason) {
      this.setState({ submittingReason: true });
      await this.props.setRemark(this.state.reason);
      if (this.props.booking) {
        await this.props.createBooking(this.props.selectedBid.id);
      } else {
        await this.props.handleConfirmBid();
      }
      this.setState({ submittingReason: false });
    } else {
      message.error('Providing reason for selecting a bid with lower rank is Mandatory');
    }
  }

  handleRemarkChange = (e) => {
    this.setState({
      reason: e.target.value,
    });
  }

  renderFooter = () => {

    return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <a style={{ color: '#595959', fontSize: `${tokens.fontSize.body}px`, marginRight: '10px', marginTop: '5px' }}
        onClick={this.props.handleCancel}>Cancel</a>
      <Button
        loading={this.state.submittingReason}
        type="primary"
        style={{ backgroundColor: tokens.colors.primary, fontSize: `${tokens.fontSize.body}px`, border: tokens.colors.primary }}
        onClick={this.setRemark}>
        {this.props.booking ? 'Book' : 'Confirm'}
      </Button>
    </div>;
  }

  render() {
    const { handleCancel, visible, selectedBid, topRankBid, currencySymbols, classes, mode } = this.props;
    const currency = selectedBid.shipperTotalWithoutTax.currency;
    const selectedBidPrice = selectedBid.shipperTotalWithoutTax.amount;
    const topBidPrice = topRankBid?.shipperTotalWithoutTax.amount;
    return <Modal style={{
      border: '1px solid #E8E8E8', borderRadius: `${tokens.radius.md}px`,
      paddingBottom: '0px', marginBottom: '10px',
    }}
      closable
      footer={this.renderFooter()}
      width="400px"
      title={<div style={{ fontWeight: 800 }}>
        {this.props.heading || 'Reason'}</div>}
      visible={visible}
      onCancel={() => handleCancel()}
    >
      <p style={{ marginBottom: '16px', font: 'Open Sans Regular', fontSize: `${tokens.fontSize.small}px` }}>
        Please share the reason for selecting a bid with lower rank.
      </p>
      <table style={{ width: '100%', padding: '2px 8px', marginBottom: '22px' }}>
        <tr>
          <td>
            <span className={`${classes.bidLabel}`}>
              Selected Bid Price
            </span>
          </td>
          <td>
            <div>
              <span className={`${classes.price}`}><sup>{currency}</sup>{selectedBidPrice.toFixed(2)}</span>
              <span className={`${classes.priceSubtext}`}>/ {getUnitByMode(mode)}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <span className={`${classes.bidLabel}`}>
              Lowest Bid Price
            </span>
          </td>
          <td>
            <div>
              <span className={`${classes.price} ${classes.opacity}`}><sup>{currency}</sup>{topBidPrice.toFixed(2)}</span>
              <span className={`${classes.priceSubtext} ${classes.opacity}`}>/ {getUnitByMode(mode)}</span>
            </div>
          </td>
        </tr>
      </table>
      <TextArea
        placeholder="Write your reason here"
        onChange={this.handleRemarkChange}
        value={this.state.reason}
        rows={3}
      />
      {this.state.showMandatoryReasonError &&
        <span style={{ backgroundColor: '#ff00002e', padding: '2px 8px', borderRadius: `${tokens.radius.sm}px` }}>
          Reason for selecting a bid with lower rank is Mandatory</span>}
    </Modal>;
  }
}

const mapStateToProps = ({ masterData, staticData }) => ({
  currencySymbols: masterData.currencySymbols,
});

export default injectSheet(styles)(connect(mapStateToProps, null)(InformReason));
